export default "/images/debag.png?0c2b7c1ad1a18fe0a9bcca9b6eb3e0ef";